import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import SettingsHome from '../containers/settings/SettingsHome';
import Tables from '../containers/settings/Tables';
import Sections from '../containers/settings/Sections';
import MyBussiness from '../containers/settings/MyBussiness';
import Branchs from '../containers/settings/Branchs';
import Taxes from '../containers/settings/Taxes';
import Waiters from '../containers/settings/Waiters';
import Error404 from '../containers/Error404';
import Suscription from "../containers/settings/Suscription";
import Payments from "../containers/settings/Payments";
import Printer from "../containers/settings/Printer";
import PaymentResponse from "../containers/settings/PaymentResponse";
import MyWeb from "../containers/settings/MyWeb";
import Gallery from "../components/settings/Gallery";
import Invoice from "../containers/settings/Invoice";
import PaymentMethods from "../containers/settings/PaymentMethods";
import QuickMenu from "../containers/settings/QuickMenu";

class SettingsRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/settings' component={SettingsHome}/>
                    <Route path='/settings/my-bussiness' component={MyBussiness}/>
                    <Route exact path='/settings/tables' component={Tables}/>
                    <Route exact path='/settings/sections' component={Sections}/>
                    <Route exact path='/settings/gallery' component={Gallery}/>
                    <Route exact path='/settings/branchs' component={Branchs}/>
                    <Route exact path='/settings/invoice' component={Invoice}/>
                    <Route exact path='/settings/taxes' component={Taxes}/>
                    <Route exact path='/settings/waiters' component={Waiters}/>
                    <Route exact path='/settings/suscription' component={Suscription}/>
                    <Route exact path='/settings/suscription/payment' component={PaymentResponse}/>
                    <Route exact path='/settings/suscription/payments' component={Payments}/>
                    <Route exact path='/settings/printer' component={Printer} />
                    <Route exact path='/settings/my-web' component={MyWeb} />
                    <Route exact path='/settings/quick-menu' component={QuickMenu} />
                    <Route exact path='/settings/payments' component={PaymentMethods} />
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default SettingsRoute;



// WEBPACK FOOTER //
// ./src/routes/SettingsRoute.js